/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMaintenanceScopeOptionClaimedByDto
 */
export interface PartnerMaintenanceScopeOptionClaimedByDto {
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeOptionClaimedByDto
     */
    partnerName: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeOptionClaimedByDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerMaintenanceScopeOptionClaimedByDto
     */
    interventionMode?: PartnerMaintenanceScopeOptionClaimedByDtoInterventionModeEnum | null;
}


/**
 * @export
 */
export const PartnerMaintenanceScopeOptionClaimedByDtoInterventionModeEnum = {
    Onsite: 'ONSITE',
    Remote: 'REMOTE'
} as const;
export type PartnerMaintenanceScopeOptionClaimedByDtoInterventionModeEnum = typeof PartnerMaintenanceScopeOptionClaimedByDtoInterventionModeEnum[keyof typeof PartnerMaintenanceScopeOptionClaimedByDtoInterventionModeEnum];


/**
 * Check if a given object implements the PartnerMaintenanceScopeOptionClaimedByDto interface.
 */
export function instanceOfPartnerMaintenanceScopeOptionClaimedByDto(value: object): value is PartnerMaintenanceScopeOptionClaimedByDto {
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceScopeOptionClaimedByDtoFromJSON(json: any): PartnerMaintenanceScopeOptionClaimedByDto {
    return PartnerMaintenanceScopeOptionClaimedByDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceScopeOptionClaimedByDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceScopeOptionClaimedByDto {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerName': json['partnerName'],
        'relationshipId': json['relationshipId'],
        'interventionMode': json['interventionMode'] == null ? undefined : json['interventionMode'],
    };
}

export function PartnerMaintenanceScopeOptionClaimedByDtoToJSON(json: any): PartnerMaintenanceScopeOptionClaimedByDto {
    return PartnerMaintenanceScopeOptionClaimedByDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceScopeOptionClaimedByDtoToJSONTyped(value?: PartnerMaintenanceScopeOptionClaimedByDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerName': value['partnerName'],
        'relationshipId': value['relationshipId'],
        'interventionMode': value['interventionMode'],
    };
}

